import AccountIndex from '../components/accounts/AccountIndex.vue';

import AccountDetails from '../components/accounts/AccountDetails.vue';


export default [
  {
    path: '/account-details/:account_id',
    name: 'AccountDetails',
    component: AccountDetails,
    meta: {
      requiresAuth: true,
      permissions: {
        Accounts: ['View Accounts']
      }
    }
  },
  {
    path: '/account-details',
    name: 'AccountIndex',
    component: AccountIndex,
    meta: {
      requiresAuth: true,
      permissions: {
        Accounts: ["*"]
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/AccountRoutes.js